const canHover = window.matchMedia('(hover: hover)').matches; //true or false


class TermsModal {
  constructor({ terms: terms, termsCheck: termsCheck }) {
    this.main = terms;
    this.checkBox = termsCheck;
    this.pageContent = terms.querySelector('.terms__page-content-inner');

    this.Click = this.Click.bind(this);

    this.Init();
  }

  Init() {
    this.main.classList.add('init');
    this.Open();

    this.FullTermsText();

    this.Eventlisteners();
  }

  Eventlisteners() {
    document.addEventListener(
      'terms:modal:open',
      () => {
        this.Open();
      },
      true
    );
  }

  Click(event) {
    if (event.target.classList.contains('terms-accept')) {
      termsCheck.checked = true;

      const submitButton = document.querySelector('.Cart__Checkout button');
      if (submitButton) {
        submitButton.click();
      }

      this.Close();
    } else if (
      event.target.classList.contains('terms-decline') ||
      !this.main.contains(event.target)
    ) {
      this.Close();
    } else if (event.target.classList.contains('expanded-close') || event.target.closest(".expanded-close")) {
      this.CloseText();
    }
  }

  FullTermsText() {
    if (this.main.hasAttribute('data-terms-page')) {
      const pageUrl = this.main.getAttribute('data-terms-page');
      const pageTitle = this.main.getAttribute('data-terms-page-title');

      if (pageUrl) {
        const termsTextLink = this.main.querySelector(
          `.terms__terms-text a[title='${ pageTitle }']`
        );
        if (termsTextLink) {
          termsTextLink.addEventListener('click', (event) => {
            event.preventDefault();

            if (this.pageContent.classList.contains('loaded')) {
              this.OpenText();
            } else {
              this.FetchFullTermsText(pageUrl);
            }
          });
        }
      }
    }
  }

  FetchFullTermsText(pageUrl) {
    return fetch(`${ pageUrl }?view=terms-content`)
      .then((response) => {
        return response.text();
      })
      .then((html) => {
        this.pageContent.insertAdjacentHTML('afterbegin', html);
        this.pageContent.classList.add('loaded');
        this.OpenText();
      })
      .catch((e) => {
        console.error(e);
      });
  }

  OpenText() {
    this.main.classList.add('expanded');
  }
  CloseText() {
    this.main.classList.remove('expanded');
  }

  Open() {
    document.addEventListener('click', this.Click);
    this.main.classList.add('active');
  }

  Close() {
    document.removeEventListener('click', this.Click);
    this.CloseText();
    this.main.classList.remove('active');
  }
}

const termsValidation = (event) => {
  const validate = () => {
    const termsCheck = document.getElementById('termsCheck');
    if (!termsCheck || termsCheck.checked == true) return;
    event.preventDefault();

    const termsModal = document.querySelector('#Terms:not(.init)');
    if (termsModal) {
      new TermsModal({ terms: termsModal, termsCheck: termsCheck });
    } else {
      document.dispatchEvent(new CustomEvent('terms:modal:open'));
    }
  };

  validate();
};

/************************* *Content block  *************************/
class ContentBlockSizer extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.init();
  }
  init() {
    let handleResize = this.debounce(() => {
      setTimeout(() => {
        this.calculateSize();
      }, 0);
    }, 50);
    window.addEventListener('resize', handleResize);
    this.calculateSize();
  }
  calculateSize() {
    void this.offsetHeight;
    let contentBlockSizerWidth = this.getBoundingClientRect().width;
    let contentBlockSizerHeight = this.getBoundingClientRect().height;

    document.documentElement.style.setProperty('--contentBlockSizerWidth', contentBlockSizerWidth + 'px');
    document.documentElement.style.setProperty('--contentBlockSizerHeight', contentBlockSizerHeight + 'px');
  }

  debounce(func, wait) {
    let timeout;
    return function() {
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(this, arguments), wait);
    };
  }
}
customElements.define('content-block-sizer', ContentBlockSizer);